import { useEffect, useState } from "react";
import axios from "axios";

// Fetch an authenticated image as a blob and expose an objectURL <img> can use.
// Replaces the inline pattern duplicated in ImageMessage.js and
// BDVersionsPanel.js/ThumbnailImage. The objectURL is revoked on cleanup
// so we don't leak blob refs across mounts.
export function useAuthImage(imageUrl, token) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!imageUrl) return undefined;
    let alive = true;
    let revokeUrl = null;
    const fullUrl = process.env.REACT_APP_BACKEND_URL
      ? `${process.env.REACT_APP_BACKEND_URL}${imageUrl}`
      : imageUrl;
    axios
      .get(fullUrl, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        responseType: "blob",
      })
      .then((r) => {
        if (!alive) return;
        revokeUrl = URL.createObjectURL(r.data);
        setSrc(revokeUrl);
      })
      .catch((e) => {
        if (alive) setError(e?.message || "load error");
      });
    return () => {
      alive = false;
      if (revokeUrl) URL.revokeObjectURL(revokeUrl);
    };
  }, [imageUrl, token]);

  return { src, error };
}
